import { Image } from 'antd';

interface IImageContainer {
    //You can either pass an icon name or and image source - this will handle both fontawesome svgs and regular images based on what you pass in
    iconName?: string,
    imageSrc?: string,

    //for fontawesome svgs, you can pass in a special class to change color src/Theme/fontawesome.css
    className?: string,

    //you can pass in custom width or margin here
    styles?: any,

    //custom title, alt and data- attribute
    title?: string,
    alt?: string,
    dataAttr?: string,
}

const ImageContainer: React.FC<IImageContainer> = props => {
    const { iconName, imageSrc, className, styles, title, alt, dataAttr } = props;

    const fontawesomeSrc = iconName && `/assets/Icons/${iconName}.svg`;

    const iconNameNoDash = iconName?.replaceAll('-', ' ');
    const altTag = alt || iconNameNoDash; //either use the alt prop OR default for fontawesome svgs to use the icon name

    return <Image
        title={title}
        src={imageSrc || fontawesomeSrc}
        style={styles || { 'width': 25 }}
        className={className}
        preview={false}
        data-image={dataAttr || `${iconName ? iconName : ''}imagecontainer`}
        alt={altTag && altTag + ' icon'}
        fallback={require(`../Images/FailedImagePlaceholder.svg`).default} //per Becky, this will show a blank white space if the image fails to load
    />
}

export default ImageContainer;
